import { createFileRoute } from '@tanstack/react-router';
import RegistrationPage from '../Containers/RegistrationPage';
import { registrationSearchParams } from '../Utils/routeSchema';

export const Route = createFileRoute('/register')({
  component: RegistrationPage,
  validateSearch: registrationSearchParams,
});
